// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-list-teams__container ul {
    list-style: none; /* Remove list bullets */
    padding: 0;
    margin-left: calc(var(--space) + var(--space-half));
}

.tournament-list-teams__container__title{
    padding: 16px 20px;
}

.tournament-list-teams__container{
    grid-area: left;
    background: var(--white-color);
    border-radius: 8px;
}

.tournament-list-teams__container__title.baloa-subtitle-1{
    color: var(--primary-very-dark-color);
}

.tournament-list-teams__add-button {
    color: var(--secondary-color);
    padding: 0px;
    height: var(--space-and-half);
    width: calc(var(--space) * 5);
    margin-top: var(--space);
    margin-bottom: var(--space);
    margin-right: var(--space-half-quarter);
    margin-left: auto;
    display: block;
}

.tournament-list-teams__list {
    overflow-y: auto;
    overflow-x: hidden;    
    max-height: calc( calc(var(--space-x3) + var(--space-half)) * 10);
}

.tournament-list-teams__list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--new-gray-background-color);
   padding: var(--space) 0;
}

.tournament-list-teams__list-item .icon-ball {
    color: var( --white-color );
    font-size: 30px;
    border-radius: 50%;
    padding: 5px;
}

.tournament-list-teams__list-item__img{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    /* float: left;
    margin-top: var(--space);
    margin-bottom: var(--space);
    margin-right: var(--space-half);
    margin-left: var(--space-half); */
}

.tournament-list-teams__list-item__text .baloa-names,
.tournament-list-teams__list-item__text .baloa-username {
    color: var(--primary-dark-color);
    margin-left: var(--space-half-quarter);
}

.tournament-list-teams__list-item__text .baloa-names {
    margin-bottom: var(--space-quarter);
}

.tournament-list-teams__list__button  {
    display: flex;
    justify-content: flex-end;   
    margin-top: var(--space-half);; 
}
.MuiFormControl-root.tournament-list-teams__list-item__add-button {
    color: var(--secondary-color);
    padding: 0px;
    height: var(--space-and-half);
    /* width: 58px; */
    /* margin-top: var(--space);
    margin-bottom: var(--space); */
    margin-right: var(--space); 
    /* margin-left: auto; */
    display: block;
}

.MuiFormLabel-root.tournament-list-teams__list-item__add-button-label {
    font-family: var(--secondary-font);
    color: var(--new-green-color);
    font-weight: var(--font-bold);
    text-transform: capitalize;
}

.MuiInputLabel-formControl.tournament-list-teams__list-item__add-button-label {
    transform: none;
}

.MuiInputBase-root.tournament-list-teams__add-button{
    display: block;
    margin-top: 0rem;
}

.MuiInput-underline.tournament-list-teams__add-button:before {
    content: "";
    border-bottom: none;
    transition: none;
}

.MuiInput-underline.tournament-list-teams__add-button:hover:not(.Mui-disabled):before {
    border-bottom: none;
}

.tournament-list-teams__add-button .MuiSvgIcon-root {
    display: none;
}

.MuiFormLabel-root.Mui-focused.tournament-list-teams__list-item__add-button-label{
    color: var(--secondary-color);
}

.tournament-list-teams__add-button.MuiInput-underline:after{
    border-bottom: none;
}
.tournament-list-teams__add-button ul.MuiList-root li {
    text-transform: uppercase;
    font-weight: var(--font-bold);
    font-size: var(--space-half-quarter);
    color: var(--primary-very-dark-color);
}

.tournament-list-teams__info-item {
    display: flex;
    align-items: center;
}

.tournament-list-teams__container .tournament-invitation-inscription-setup__teams-filter {
    display: flex;
    align-items: center;
    margin-left: var(--space);
}

.tournament-set-groups__list-item._disabled{
    padding: var(--space-half);   
}

.tournament-list-teams__list-item._disabled{
    padding: var(--space-half);
}

.tournament-list-teams__container__subtitle{
    margin-left: calc(var(--space) + var(--space-half));
    margin-bottom: var(--space);
}

.tournament-list-teams__container__subtitle.baloa-names{
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.tournament-list-teams__container_automaticGroups{
    margin: var(--space);
}

.tournament-list-teams__container_automaticGroups .hubicon-shuffle{
    grid-area: icon;
    margin-right: var(--space-half);
}

.tournament-list-teams__phase-edit__add-button-label.baloa-hyperlink-2 {
    color: var(--new-green-color);
    padding: var(--space);
    cursor: pointer;
}

.tournament-list-teams__phase-edit__add-button-label.baloa-hyperlink-2.disabled {
    opacity: 0.64;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-list-teams/TournamentListTeamsComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB,EAAE,wBAAwB;IAC1C,UAAU;IACV,mDAAmD;AACvD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,6BAA6B;IAC7B,6BAA6B;IAC7B,wBAAwB;IACxB,2BAA2B;IAC3B,uCAAuC;IACvC,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iEAAiE;AACrE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yDAAyD;GAC1D,uBAAuB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB;;;;qCAIiC;AACrC;;AAEA;;IAEI,gCAAgC;IAChC,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,6BAA6B;AACjC;AACA;IACI,6BAA6B;IAC7B,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB;kCAC8B;IAC9B,0BAA0B;IAC1B,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,6BAA6B;IAC7B,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mDAAmD;IACnD,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".tournament-list-teams__container ul {\n    list-style: none; /* Remove list bullets */\n    padding: 0;\n    margin-left: calc(var(--space) + var(--space-half));\n}\n\n.tournament-list-teams__container__title{\n    padding: 16px 20px;\n}\n\n.tournament-list-teams__container{\n    grid-area: left;\n    background: var(--white-color);\n    border-radius: 8px;\n}\n\n.tournament-list-teams__container__title.baloa-subtitle-1{\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-list-teams__add-button {\n    color: var(--secondary-color);\n    padding: 0px;\n    height: var(--space-and-half);\n    width: calc(var(--space) * 5);\n    margin-top: var(--space);\n    margin-bottom: var(--space);\n    margin-right: var(--space-half-quarter);\n    margin-left: auto;\n    display: block;\n}\n\n.tournament-list-teams__list {\n    overflow-y: auto;\n    overflow-x: hidden;    \n    max-height: calc( calc(var(--space-x3) + var(--space-half)) * 10);\n}\n\n.tournament-list-teams__list-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid var(--new-gray-background-color);\n   padding: var(--space) 0;\n}\n\n.tournament-list-teams__list-item .icon-ball {\n    color: var( --white-color );\n    font-size: 30px;\n    border-radius: 50%;\n    padding: 5px;\n}\n\n.tournament-list-teams__list-item__img{\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    /* float: left;\n    margin-top: var(--space);\n    margin-bottom: var(--space);\n    margin-right: var(--space-half);\n    margin-left: var(--space-half); */\n}\n\n.tournament-list-teams__list-item__text .baloa-names,\n.tournament-list-teams__list-item__text .baloa-username {\n    color: var(--primary-dark-color);\n    margin-left: var(--space-half-quarter);\n}\n\n.tournament-list-teams__list-item__text .baloa-names {\n    margin-bottom: var(--space-quarter);\n}\n\n.tournament-list-teams__list__button  {\n    display: flex;\n    justify-content: flex-end;   \n    margin-top: var(--space-half);; \n}\n.MuiFormControl-root.tournament-list-teams__list-item__add-button {\n    color: var(--secondary-color);\n    padding: 0px;\n    height: var(--space-and-half);\n    /* width: 58px; */\n    /* margin-top: var(--space);\n    margin-bottom: var(--space); */\n    margin-right: var(--space); \n    /* margin-left: auto; */\n    display: block;\n}\n\n.MuiFormLabel-root.tournament-list-teams__list-item__add-button-label {\n    font-family: var(--secondary-font);\n    color: var(--new-green-color);\n    font-weight: var(--font-bold);\n    text-transform: capitalize;\n}\n\n.MuiInputLabel-formControl.tournament-list-teams__list-item__add-button-label {\n    transform: none;\n}\n\n.MuiInputBase-root.tournament-list-teams__add-button{\n    display: block;\n    margin-top: 0rem;\n}\n\n.MuiInput-underline.tournament-list-teams__add-button:before {\n    content: \"\";\n    border-bottom: none;\n    transition: none;\n}\n\n.MuiInput-underline.tournament-list-teams__add-button:hover:not(.Mui-disabled):before {\n    border-bottom: none;\n}\n\n.tournament-list-teams__add-button .MuiSvgIcon-root {\n    display: none;\n}\n\n.MuiFormLabel-root.Mui-focused.tournament-list-teams__list-item__add-button-label{\n    color: var(--secondary-color);\n}\n\n.tournament-list-teams__add-button.MuiInput-underline:after{\n    border-bottom: none;\n}\n.tournament-list-teams__add-button ul.MuiList-root li {\n    text-transform: uppercase;\n    font-weight: var(--font-bold);\n    font-size: var(--space-half-quarter);\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-list-teams__info-item {\n    display: flex;\n    align-items: center;\n}\n\n.tournament-list-teams__container .tournament-invitation-inscription-setup__teams-filter {\n    display: flex;\n    align-items: center;\n    margin-left: var(--space);\n}\n\n.tournament-set-groups__list-item._disabled{\n    padding: var(--space-half);   \n}\n\n.tournament-list-teams__list-item._disabled{\n    padding: var(--space-half);\n}\n\n.tournament-list-teams__container__subtitle{\n    margin-left: calc(var(--space) + var(--space-half));\n    margin-bottom: var(--space);\n}\n\n.tournament-list-teams__container__subtitle.baloa-names{\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.tournament-list-teams__container_automaticGroups{\n    margin: var(--space);\n}\n\n.tournament-list-teams__container_automaticGroups .hubicon-shuffle{\n    grid-area: icon;\n    margin-right: var(--space-half);\n}\n\n.tournament-list-teams__phase-edit__add-button-label.baloa-hyperlink-2 {\n    color: var(--new-green-color);\n    padding: var(--space);\n    cursor: pointer;\n}\n\n.tournament-list-teams__phase-edit__add-button-label.baloa-hyperlink-2.disabled {\n    opacity: 0.64;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
